import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import AvatarSec from "../module-common/Avatar";
import moment from "moment";
import { Scrollbars } from "react-custom-scrollbars";
import ContentBubble from "./ContentBubble";
import Ava from "../assets/avatar.png";
import { fromByteArray } from "ipaddr.js";
import { AgentCareStore } from "../Store";
export default class ContentListView extends Component {
  static propTypes = {
    messages: PropTypes.array,
    scrollRef: PropTypes.func,
    onEndReached: PropTypes.func,
    image: PropTypes.string
  };
  static defaultProps = { messages: [] };
  scrollHeight = 0;

  componentDidMount() {
    this.scroller.scrollToBottom();
  }

  componentWillUpdate() {
    // remember scroll height before new message arrive
    this.scrollHeight = this.scroller.getScrollHeight();
  }
  render() {
    const scrollRef = this.props.scrollRef;

    return (
      <Wrapper>
        <Scrollbars
          ref={ref => {
            this.scroller = ref;
            if (scrollRef) scrollRef(ref);
          }}
          onScrollFrame={this.onScrollFrame}
        >
          <ContentSec>{this.renderMessages()}</ContentSec>
        </Scrollbars>
      </Wrapper>
    );
  }

  renderMessages = () => {
    const { messages } = this.props;
    const renders = [];
    const image = AgentCareStore.displayPicture;
    const avatarDisplay =
      image !== "" ? (
        <AvatarSec image={this.image} isSmall={true} isChat={true} />
      ) : (
        <AvatarSec image={Ava} isSmall={true} isChat={true} />
      );

    for (var key in messages) {
      const message = messages[key];
      let fromAgent = message.from === "me" ? false : true;
      let showTimestamp;
      let nextKey = parseInt(key);
      if (nextKey >= 0 && nextKey < messages.length - 1) {
        let nextMessage;
        nextMessage = messages[nextKey + 1];
        if (nextMessage.timestamp === message.timestamp) {
          showTimestamp = false;
        } else {
          showTimestamp = true;
        }
      } else {
        showTimestamp = true;
      }

      renders.push(
        <WrapperBubble>
          {fromAgent ? (
            <AvatarWrapper>
              {AgentCareStore.displayPicture !== "" ? (
                <AvatarSec
                  image={AgentCareStore.displayPicture}
                  isSmall={true}
                  isChat={true}
                />
              ) : (
                <AvatarSec image={Ava} isSmall={true} isChat={true} />
              )}
            </AvatarWrapper>
          ) : (
            ""
          )}

          <ContentBubble
            content={message.text}
            name={message.name}
            type={message.type}
            fromAgent={fromAgent}
            timestamp={new moment(message.timestamp)}
            showTimestamp={showTimestamp}
          />
        </WrapperBubble>
      );
    }
    return renders;
  };
  onScrollFrame = event => {
    // if at end of border, trigger event
    if (event.top === 0) {
      const onEndReached = this.props.onEndReached;
      onEndReached && onEndReached();
    }
  };
}

const Wrapper = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  width: 100%;
  height: 85%;
  overlay-y: auto;
`;
const ContentSec = styled.div`
  display: flex;
  flex-direction: column;
`;
const WrapperBubble = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
`;
const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
  height: 100%;
  align-content: center;
  margin-left: 10px;
  margin-right: -10px;
`;



// WEBPACK FOOTER //
// ./src/chat/Content.js